import React from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip, Box } from "@mui/material";

import AppConfirmDialog from "components/Shared/AppConfirmDialog";
import DateRangeToggle from "components/Shared/DateRangeToggle";

import { exportExcelFile } from "utils/exportExcelFile";
import moment from "moment";
import { useLazyNoPriceShipmentListQuery } from "store/services/reportApi";

const EXCEL_DATA_INITIAL_STATE = {
  dateRange: [],
  responsibleUser: null,
};

const ExportNoPriceShipmentExcel = ({ isBusy = false }) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const [setShowVendorForm] = React.useState(false);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: EXCEL_DATA_INITIAL_STATE,
  });

  // RTK Query implementation
  const [fetchNoPriceShipments] = useLazyNoPriceShipmentListQuery();

  const handleDownload = async (data) => {
    const { dateRange } = data;

    const fromDate = moment(dateRange[0]).format("YYYY-MM-DD");
    const toDate = moment(dateRange[1]).format("YYYY-MM-DD");

    const payload = {
      fromDate,
      toDate,
    };

    try {
      const responseData = await fetchNoPriceShipments(payload).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No records found for the selected date range and filters.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        "Shipment ID": row?.shipmentId || "N/A",
        Sender: row?.vendor?.name || row?.customer?.name || "N/A",
        Receiver: row?.receiver?.name || "N/A",
        "From ": row?.sourceBranch?.name || "N/A",
        "To ": row?.destinationBranch?.name || "N/A",
        Status: row?.status || "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "No_Price_Shipment",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error("Error fetching data: " + error.message);
    }
    handleReset();
  };

  const handleReset = () => {
    setShowDialog(false);
    setShowVendorForm(false);
    reset(EXCEL_DATA_INITIAL_STATE);
  };

  return (
    <>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={() => setShowDialog(true)}
          disabled={isBusy}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>

      <AppConfirmDialog
        open={showDialog}
        onClose={handleReset}
        onConfirm={handleSubmit(handleDownload)}
        title="Download No Price Shipment Excel"
        dialogIcon={() => <FileDownloadOutlined color="success" />}
        fullWidth
      >
        <Box sx={{ display: "flex", gap: 2, ml: 3 }}>
          <Controller
            name="dateRange"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <DateRangeToggle {...field} label="Select Date Range" />
            )}
          />
        </Box>
      </AppConfirmDialog>
    </>
  );
};

export default ExportNoPriceShipmentExcel;
